import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

// *******************toster****************************
import ModalSave from "../../../common/ModelSave";
import { CancelButton, SaveButton } from "../../../common/Button";

import {
  Row,
  Col,
  Form,
  InputGroup,
  Modal,
  Table,
  Button,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { logDOM } from "@testing-library/react";
const moment = require("moment");
library.add(fas);

const ShowKYC = (props) => {
  const data = props.show;
  const { postData, getData, IMG_URL, Select2Data, editStatusData } =
    useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });



  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="AddOffCanvance_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Payment Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="package-details-section mb-3">
            <div className="row">


              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
                <div className="box_hodler">
                  <h6>Message</h6>

                  <p>{data?.Order_Payment_Detail?.message}</p>
                </div>
              </div>



              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
                <div className="box_hodler">
                  <h6>Payment Proof Image</h6>

                  <img
                    src={IMG_URL + data?.Order_Payment_Detail?.payment_proof}
                    alt="Order Icon"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      // margin: "10px 0",
                    }}
                  />
                </div>
              </div>

              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
                <div className="box_hodler">
                  <h6>Other Image</h6>
                  <img
                    src={IMG_URL + data?.Order_Payment_Detail?.other_image}
                    alt="Order Icon"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      // margin: "10px 0",
                    }}
                  />
                </div>
              </div>




            </div>
          </div>
        </Modal.Body>
        <Row className="mt-5 pb-3">
          <div className="d-flex justify-content-center">
            <Link>
              <CancelButton name={"Close"} handleClose={props.handleClose} />
            </Link>
          </div>
        </Row>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default ShowKYC;
